import { useCallback } from 'react';
import { message } from 'antd';
import * as handlebars from 'handlebars';

import { handoverTemplate } from '../templates';
import { IAuthUser } from '@modules/auth';
import moment from 'moment';
import { Constants } from '@core/constants';
import { isEmpty } from 'lodash';

const registerHandlebarsHelpers = () => {
  if ((handlebars as any)._helpersRegistered) return;

  handlebars.registerHelper('addOne', (value: any) => parseInt(value) + 1);
  handlebars.registerHelper('eq', (a: any, b: any) => a === b);

  (handlebars as any)._helpersRegistered = true;
};

const renderTemplate = async (templateUrl: string, context: Record<string, any>): Promise<string> => {
  const templateText = await fetch(templateUrl).then((r) => r.text());
  return handlebars.compile(templateText)(context);
};

const openPrintWindow = (html: string) => {
  const printWindow = window.open();
  if (!printWindow) throw new Error('Brauzerdə xəta baş verdi.');
  printWindow.document.write(html);
  printWindow.document.close();
};

export const printHandoverCheck = async (user: IAuthUser | null, handoverTaskId: number | string, data: Record<string, any>) => {
  if (!handoverTaskId || isEmpty(data)) return;

  registerHandlebarsHelpers();
  const hide = message.loading('Çek hazırlanır.', 0);

  try {
    const renderedTemplate = await renderTemplate(handoverTemplate, {
      ...data,
      warehouseman: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim(),
      checkDate: moment().format(Constants.DATE_TIME),
      handoverTaskId: `HT${handoverTaskId}`,
    });

    hide();
    openPrintWindow(renderedTemplate);
  } catch (e: any) {
    hide();
    message.error(e.message || 'Şablon əldə edilə bilmədi.');
  }
};

export const usePrintHandoverCheck = (user: IAuthUser | null, handoverTaskId: string | number) => {
  return useCallback(
    async (data: any) => {
      await printHandoverCheck(user, handoverTaskId, data);
    },
    [user, handoverTaskId],
  );
};
